import { setApplyDetails, setProductDetails, resetSalesReqBody, resetFormData, setCurrentStep, clearProductDetails, setPrefetchProducts, setApplyStep  } from "../../features/FormRegistration";
import { useDispatch } from "react-redux";
import StartOverModal from "../StartOverModal";
import { useDisclosure } from "@mantine/hooks";

interface StartOverProps { 
  message?: string;
}

export default function StartOver({ message = "Are you sure you want to start over?" }: StartOverProps) {
  const dispatch = useDispatch();
  const [opened, { open, close }] = useDisclosure(false);

  const handleStartOver = () => {
    //open confirm dialog from window.confirm
     dispatch(setCurrentStep(0));
    localStorage.clear();
    dispatch(resetFormData());
    dispatch(resetSalesReqBody());
    dispatch(setApplyDetails(null));
    dispatch(setProductDetails(null));
    dispatch(clearProductDetails());
    dispatch(setPrefetchProducts({}));
    dispatch(setApplyStep(-1));
    
  }
  return (
    <>
    
       <span className="text-[16px] font-bold ml-5 cursor-pointer" onClick={open}>Start Over</span>  
      <StartOverModal message={message} onStartOver={handleStartOver} onCancel={close} opened={opened} close={close} />
    </>
  );
}